export default "__VITE_ASSET__6351ad3e__"